import {requestHelpers} from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
  SET_SUMMARY: "SET_SUMMARY",
  GENERAL_SUMMARY_REQUEST: "GENERAL_SUMMARY_REQUEST",
  GENERAL_SUMMARY_SUCCESS: "GENERAL_SUMMARY_SUCCESS",
  GENERAL_SUMMARY_ERROR: "GENERAL_SUMMARY_ERROR",
  DELETE_SUMMARY_SUCCESS: "DELETE_SUMMARY_SUCCESS"
};

export const setSummary = (profile) => {

  const noData = profile.profile[0].summary === null;
  return {
    type: actions.SET_SUMMARY,
    person_id: profile.id,
    id: profile.profile[0].id,
    // network_id: profile.profile[0].network_id,
    visible: profile.profile[0].visible,
    body: profile.profile[0].summary,
    noData
  }
};

export const summaryApiCall = (personId, payload, type, callback) => {
  const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : 'DELETE' );
  const endpoint = requestType !== "DELETE" ? '' : ( payload ? `/${ payload }` : '' );
  return (dispatch) => {
    dispatch({
      type: actions.GENERAL_SUMMARY_REQUEST,
      isSummaryFetching: true,
      isSummaryError: false
    });

    requestHelpers
      .authenticatedPostRequest(`/profiles/${personId}/summary${ endpoint }`, payload, requestType)
      .then((response) => {
        const noData = type === 'DELETE';
        callback();
        return dispatch({
          type: actions.GENERAL_SUMMARY_SUCCESS,
          body: payload && payload.summary,
          personId,
          noData: noData,
          isSummaryFetching: false,
          isSummaryError: false
        })
      })
      .catch((error) => {
        return callback(error);
      })
    dispatch(updateTodoList(personId, 8));
  }
};







// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/summary.js